export default "__VITE_ASSET__fa3aacf5__"